import { BaseModel } from './base.model';
import { Deserializable } from './deserializable';
import { MorphModel } from './morph.model';

export class SentmessageModel extends BaseModel implements Deserializable {

  // columns
  type: string;
  recipient: string;
  title: string;
  content: string;
  sended_at: any;

  // relations
  owner: MorphModel;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }

}
